export const isEmptyHtmlParagraph = (value?: string): boolean => {
	if (!value) return true;
	return value.trim() === '<p></p>';
};
